import { render, staticRenderFns } from "./main-no-menu.vue?vue&type=template&id=becb5cb0"
import script from "./main-no-menu.vue?vue&type=script&lang=js"
export * from "./main-no-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports